import { ImageScreen } from "models";
import { TextSections } from "modules/expo-export/typings";
import { addText, addInfopoints } from "../common-text-parsers";

export const parseImageScreen = (
  screen: ImageScreen,
  sections: TextSections
): void => {
  addText(sections, "Text obrazovky", screen.text);
  addInfopoints(sections, screen.infopoints);
};
